<template>
  <div class="invoice-list">
    <div class="bar">
      <label>已选金额: </label>
      <span class="bar-price">¥{{ selectMoney }}</span>
      <el-button type="primary" size="mini" @click="askBtnClick"
        >索取发票</el-button
      >
    </div>
    <el-form
      :inline="true"
      class="qForm"
      size="small"
      :model="queryParams"
      label-width="115px"
    >
      <el-form-item label="委托单号">
        <el-input
          v-model="queryParams.orderId"
          placeholder="请输入委订单编号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="订单金额">
        <div class="flex">
          <el-input
            v-model="queryParams.beginOrderPrice"
            placeholder="请输入"
            clearable
            class="qForm-price"
          ></el-input>
          <span> -- </span>
          <el-input
            v-model="queryParams.endOrderPrice"
            placeholder="请输入"
            clearable
            class="qForm-price"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="商家名称">
        <el-input
          v-model="queryParams.checkmallBusinessName"
          placeholder="请输入商家名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="下单时间">
        <el-date-picker
          v-model="queryDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          class="qForm-time"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="myTable">
      <AskTable
        :data="tableData"
        :money.sync="selectMoney"
        :selection.sync="selectionData"
        :loading="tableLoading"
        ref="askTable"
      />
    </div>
    <!-- 分页-->
    <!-- 分页-->
    <Pagination
      :total="totalItem"
      :page="page"
      @pageIndexChange="handlePageChange"
    />
    <el-drawer
      title="设置发票类型及备注"
      :visible.sync="showDrawer"
      :wrapperClosable="false"
      v-if="showDrawer"
      size="700px"
      class="drawer"
    >
      <div class="drawer-form">
        <BillForm ref="bill" />
        <div class="drawer-btn">
          <el-button
            type="primary"
            plain
            size="small"
            @click="submit"
            :loading="loginBtnLoading"
            >确认提交</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination/index";
import { applyInvoice, getInvoiceList } from "@/api/userCenter";
import AskTable from "./AskBillTable.vue";
import BillForm from "./ReserveBillForm.vue";
export default {
  components: {
    Pagination,
    AskTable,
    BillForm,
  },
  data() {
    return {
      showDrawer: false, // 索取发票弹层
      totalItem: 0, // 总数量
      selectMoney: 0, // 表格选中数据的总钱数
      // 分页数据
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      selectionData: [], // 选中的订单
      // 表格数据
      tableData: [],
      loginBtnLoading: false,
      queryParams: {},
      queryDate: [],
      tableLoading: false,
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    // 翻页处理
    handlePageChange(page) {
      this.page = page;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getTableData();
    },

    // 查询
    handleQuery() {
      this.page.pageIndex = 1;
      this.getTableData();
    },

    // 索取发票按钮
    askBtnClick() {
      if (!this.selectionData.length) {
        this.$message.warning("请先选择订单");
        return;
      }
      this.showDrawer = true;
    },

    async getTableData() {
      const params = {
        ...this.page,
        ...this.queryParams,
      };
      const { queryDate } = this;
      if (queryDate && queryDate.length) {
        const [start, end] = queryDate;
        Object.assign(params, {
          beginCreateTime: start,
          endCreateTime: end,
        });
      }
      this.tableLoading = true;
      const data = await this.$axios
        .post(getInvoiceList, {
          ...params,
        })
        .finally(() => {
          this.tableLoading = false;
        });
      this.$refs.askTable.orderCompany = "";
      const { list, totalItem } = data;
      this.tableData = list;
      this.totalItem = totalItem;
    },

    // 索取发票确定
    async submit() {
      const orderIds = [];
      this.selectionData.forEach((item) => {
        orderIds.push(item.orderId);
      });

      const invoiceApplyBaseinfo = this.$refs.bill.form;
      const { invoiceRemark, invoiceApplyExplain, ...rest } =
        invoiceApplyBaseinfo;
      const params = {
        invoiceAmount: this.selectMoney,
        orderId: orderIds.join(","),
        invoiceApplyExplain: invoiceApplyExplain,
        invoiceRemark: invoiceRemark,
        htInvoiceApplyBaseinfo: rest,
        orderType: 0,
      };
      await this.$confirm(
        `确定索取发票抬头为“${invoiceApplyBaseinfo.invoiceTitle}”的发票吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      );
      this.loginBtnLoading = true;
      await this.$axios
        .post(applyInvoice, {
          ...params,
        })
        .finally(() => {
          this.loginBtnLoading = false;
        });
      this.selectionData = [];
      this.getTableData();
      this.showDrawer = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.bar {
  padding: 10px 10px;
  background: #eaf1fe;
  text-align: right;
  &-price {
    margin-right: 10px;
    color: $theme-color;
  }
}
.myTable {
  margin-bottom: 10px;
  min-height: 500px;
}
.drawer {
  // ::v-deep .el-drawer__header {
  //   margin-bottom: 10px;
  // }
  &-form {
    padding: 0 15px;
  }
  &-btn {
    padding-left: 160px;
  }
}

.qForm {
  // height: 45px;
  overflow: hidden;
  margin-top: 10px;
  &.contentExpend {
    height: auto;
  }
  ::v-deep.el-form-item {
    margin-bottom: 10px;
  }
  ::v-deep .el-date-editor {
    width: 400px;
  }
  &-price {
    width: 100px;
  }
  &-time {
    width: 300px !important;
  }
}
</style>
